export default "/assets/images/girl.44b3fec29d109d37.webp";